/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-versi': {
    width: 18,
    height: 21,
    viewBox: '0 0 18 21',
    data: '<path pid="0" d="M8.949 18.36a.64.64 0 01.639-.638h7.67a.64.64 0 110 1.278h-7.67a.64.64 0 01-.64-.64zM8.949 15.165a.64.64 0 01.639-.64h7.67a.64.64 0 110 1.279h-7.67a.64.64 0 01-.64-.64zM5.654 19h1.377l-2.787-6.392H2.787L0 19h1.377l.511-1.278h3.255L5.654 19zM2.4 16.443l1.116-2.79 1.116 2.79H2.4zM0 10.051a.64.64 0 01.64-.639h16.618a.64.64 0 010 1.278H.64A.64.64 0 010 10.052zM8.949 4.938a.64.64 0 01.639-.64h7.67a.64.64 0 110 1.279h-7.67a.64.64 0 01-.64-.64zM8.949 1.742a.64.64 0 01.639-.64h7.67a.64.64 0 110 1.279h-7.67a.64.64 0 01-.64-.64zM5.654 7.495h1.377L4.244 1.103H2.787L0 7.495h1.377l.511-1.279h3.255l.511 1.279zM2.4 4.938l1.116-2.79 1.116 2.79H2.4z" _fill="#000"/>'
  }
})
